import { useEffect, useState } from "react"
import {
  LoadableIntroduction,
  LoadableNavbar,
  LoadableProducts,
  LoadableServices,
  LoadableTechnology,
  LoadableAboutUs,
  LoadableBanner,
  LoadableFooter,
  LoadableContact,
  LoadableScrollTop,
} from "../components"

export default function Home() {
  const [enableScroller, setEnableScroller] = useState(false)

  // Enable the scroller
  const renderScrollerComponent = () => {
    if (window.pageYOffset > 100) {
      setEnableScroller(true)
    } else {
      setEnableScroller(false)
    }
  }

  useEffect(() => {
    // This will work only for client side
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", renderScrollerComponent)
      return () => {
        window.removeEventListener("scroll", renderScrollerComponent)
      }
    }
  }, [])

  return (
    <div>
      <LoadableNavbar />
      <LoadableIntroduction />
      <LoadableServices />
      <LoadableProducts />
      <LoadableTechnology />
      <LoadableAboutUs />
      <LoadableContact />
      <LoadableBanner />
      <LoadableFooter />
      {enableScroller && <LoadableScrollTop />}
    </div>
  )
}
